import {
    people1,
    people2,
    people3,
    people4,
    people5,
    people6,
    people7
} from "./../../helper/constant";

export const mentions = [
    {
        first: "alex",
        last: "hales",
        username: "alex123",
        pics: people1
    },
    {
        first: "mark",
        last: "wood",
        username: "mark345",
        pics: people2
    },
    {
        first: "max",
        last: "well",
        username: "max234",
        pics: people3
    },
    {
        first: "smith",
        last: "stone",
        username: "smith007",
        pics: people4
    },
    {
        first: "amber",
        last: "hyden",
        username: "amhed123",
        pics: people5
    },
    {
        first: "devid",
        last: "bravo",
        username: "bravo90",
        pics: people6
    },
    {
        first: "hello",
        last: "world",
        username: "world123",
        pics: people7
    }
];

export const demoText = `* Roe Provide a beautiful _markup editor_ using core javascript with React js.*
    1) *Bold* => Command + B
    2) _Italic_ => Command + I
    3) @alex123  => Use @ for Mentioning user
    4) 😀 => Use :(colon) for emojies
    5) Url =>  http://roe-preview.hexesis.com
    6) *Bullet List* : 
    - Multi features
    - Custom javascript
    - Awesome custom *RoeMarkUpEditor* component
`;

export const forEditText = `> for-editor is a markdown editor

# for-editor

this is a markdown editor

## for-editor

this is a markdown editor

### for-editor

- item1
  - subitem1
  - subitem2
  - subitem3
- item2
- item3

---

1. item1
2. item2
3. item3

### table

| title      | description     |
| ---------- | --------------- |
| for-editor | markdown editor |
`
